import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import { Simulate } from "react-dom/test-utils";
var error = Simulate.error;
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
export var api__checkFinanceEligibility = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    var apiUrl, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          apiUrl = "/finance/eligibility-check";
          _context.p = 1;
          _context.n = 2;
          return fetcher().post(apiUrl, data);
        case 2:
          res = _context.v;
          return _context.a(2, res.data.data);
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2, error(_t.message));
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function api__checkFinanceEligibility(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getProductDetails = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(product_id) {
    var data, requestData, axiosConfig;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          data = {
            filters: {
              post_id: product_id
            }
          };
          requestData = {
            search_data: JSON.stringify(data || {})
          };
          axiosConfig = {
            params: requestData
          };
          return _context3.a(2, fetcher(null).get("/search/index", axiosConfig).then(/*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
              var _res$data, _res$data2, _res$data2$data;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) !== 200)) {
                      _context2.n = 1;
                      break;
                    }
                    throw new InternalServerError500Exception("api__doSearch", {
                      url: "search/index",
                      data: axiosConfig.params
                    });
                  case 1:
                    return _context2.a(2, (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : _res$data2$data.products) || {});
                }
              }, _callee2);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }()));
      }
    }, _callee3);
  }));
  return function api__getProductDetails(_x2) {
    return _ref2.apply(this, arguments);
  };
}();